import React from "react";
import { Line } from "react-chartjs-2";

/**
 * GuestCountsByDayReport
 *
 * Renders a line chart of guest counts by category (Solo, Couple, etc.) for each day,
 * along with a print-only details table.
 *
 * Props:
 * - chartData: { labels: string[], datasets: Array }
 * - chartOptions: Object
 * - storess: string (store name)
 * - range: { tran_date: { $gte: string, $lte: string } }
 * - chartRef: React.RefObject
 * - containerId: string
 */
const GuestCountsByDayReport = ({
  chartData,
  chartOptions,
  storess,
  range,
  chartRef,
  containerId,
}) => {
  const startDate = range.tran_date.$lte.split("T")[0];
  const endDate = range.tran_date.$gte.split("T")[0];

  return (
    <div ref={chartRef} id={containerId}>
      <div className="card">
        <Line data={chartData} options={chartOptions} />
      </div>

      <div className="print-only-content">
        <h2>Report Details</h2>
        <div className="print-only-content">
          <div>
            <h3>Brand: Angels Pizza</h3>
            <h3>Store: {storess}</h3>
            <h3>Date: {`${startDate} ${endDate}`}</h3>
          </div>
        </div>

        <div style={{ fontSize: "20px" }}>
          <table className="table text-center">
            <thead className="text-center">
              <tr className="text-center">
                <th>Day</th>
                <th>Guest Count Solo</th>
                <th>Guest Count Couple</th>
                <th>Guest Count Small Group</th>
                <th>Guest Count Medium Group</th>
                <th>Guest Count Large Group</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {chartData.labels.map((label, index) => (
                <tr key={label} className="text-center">
                  <td>{label}</td>
                  {chartData.datasets.map((ds, i) => (
                    <td key={i}>{ds.data[index]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GuestCountsByDayReport;
